export default function TabPanel({ value, index, children }) {
  if (value !== index) return null
  return children
}

